// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination-module__pagination--bJ6Q6","page":"Pagination-module__page--VBohH","active":"Pagination-module__active--RIwyx"};